/**
 * Returns the height in pixels of a given element from the top of the page.
 *
 * @param element
 */
export default function getHeightFromTopOfPage(element: HTMLElement): number {
  let height = element.offsetTop
  let parent = element.parentElement
  while (parent) {
    height += parent.offsetTop
    parent = parent.offsetParent as HTMLElement
  }
  return height
}
